export default {
  playGameBtn: 'เล่นเกมส์',
  login: {
    loginTitle: 'เข้าสู่ระบบ',
    phoneLabel: 'เบอร์โทรศัพท์',
    passwordLabel: 'รหัสผ่าน',
    loginBtn: 'เข้าสู่ระบบ',
    registerLink: 'สมัครสมาชิก'
  },
  register: {
    registerTitle: 'สมัครสมาชิก',
    nameLabel: 'ชื่อโปรไฟล์',
    usernameLabel: 'เบอร์โทร',
    passwordLabel: 'รหัสผ่าน',
    confirmPasswordLabel: 'ยืนยันรหัสผ่าน',
    sourceLabel: 'ช่องทางที่รู้จัก',
    sourceSelect: 'เลือกช่องทาง',
    parentLabel: 'คนแนะนำ',
    bankData: 'ข้อมูลธนาคาร',
    bankLabel: 'ธนาคาร',
    bankSelect: 'เลือกธนาคาร',
    warningBankOne: '*** แนะนำให้ใช้บัญชี',
    warningBankTwo: 'กสิกรหรือ',
    warningBankThree: 'กรุงไทย (ระบบจะมีความรวดเร็วที่สุด) ***',
    bankAccountNoLabel: 'เลขที่บัญชี',
    bankAccountNameLabel: 'ชื่อ-นามสกุลบัญชี',
    registerBtn: 'สมัครสมาชิก',
    passwordNotEqualMsg: 'รหัสผ่านไม่ตรงกัน',
    registerSuccessMsg: 'สมัครสมาชิกเรียบร้อยแล้ว',
    nextBtn: 'ดำเนินการต่อ',
    otpLabel: 'รหัส OTP',
    confPhoneLabel: 'ยืนยันเบอร์โทร',
    profileLabel: 'ข้อมูลส่วนตัว',
    currencyLabel: 'สกุลเงิน',
    languageTxt: '(ภาษาอังกฤษ)',
    requiredEngLangMsg: 'ชื่อบัญชีต้องเป็นภาษาอังกฤษเท่านั้น',
    accountFirstname: 'ชื่อเท่านั้น',
    accountLastname: 'นามสกุลเท่านั้น'
  },
  howTo: {
    howToTitle: 'วิธีการใช้งาน',
    walletTitle: 'ขั้นตอนการใช้ Wallet',
    playTitle: 'วิธีการเข้าเล่นเกม',
    balanceTitle: 'ขั้นตอนการกดเช็คยอดเงิน',
    bonusTitle: 'ขั้นตอนการรับโบนัส',
    bonusCancelTitle: 'ขั้นตอนการยกเลิกโบนัส'
  },
  home: {
    checkBalance: 'เช็คเงินปัจจุบัน',
    updateTime: 'อัพเดทเมื่อ',
    allBaht: '{total} บาท',
    allCoin: '{totalCoin} เหรียญ',
    referBonusLabel: 'โบนัสแนะนำเพื่อน',
    receiveBtn: 'รับ',
    depositTitle: 'เติมเงิน',
    refreshAllTitle: 'เช็คยอดเงิน',
    transferTitle: 'โยกเงิน',
    withdrawTitle: 'ถอนเงิน',
    inviteTitle: 'แนะนำเพื่อน',
    bonusTitle: 'โบนัส',
    refundTitle: 'คืนยอดเสีย',
    rankingTitle: 'อัพแรงค์',
    slotAccountLabel: 'บัญชีสล๊อต',
    viewDataTitle: 'แตะเพื่อดูข้อมูล',
    openAccountTitle: 'เปิดบัญชีเกมส์นี้',
    sportAccountLabel: 'บัญชีกีฬา + คาสิโน',
    lottoAccountLabel: 'บัญชีหวย',
    receivedInviteBonusMsg: 'ต้องการรับโบนัสแนะนำเพื่อน',
    confirmMsg: 'ต้องการ',
    cancelMsg: 'ไม่ต้องการ',
    successMsg: 'สำเร็จ',
    condition1Msg:
      'หากท่านกดรับ จะทำให้เงินใน wallet และ เกมทั้งหมด ติดเงื่อนไขด้วย',
    condition2Msg: 'เงื่อนไข ต้องทำให้ได้เงิน',
    condition3Msg: 'ของยอดโบนัสแนะนำเพื่อน',
    condition4Msg: 'การยกเลิกโบนัส หากยอดเงินฝากรวมโบนัสต่ำกว่า',
    condition5Msg: 'สมาชิกต้องกดยกเลิกโบนัสก่อนทำรายการฝากครั้งต่อไป',
    condition6Msg: 'ไม่กดเงินฝากจะติดเทิร์น'
  },
  bonus: {
    bonusTitle: 'โบนัส',
    cancelBtn: 'ยกเลิก',
    promoCodePla: 'รหัสโปรโมชั่น',
    searchBtn: 'ค้นหา',
    bonusReceived: 'คุณรับโบนัสนี้ไปแล้ว',
    bonusClick: 'กดรับโบนัส',
    currentPromotionMsg: 'โปรโมชั่นปัจจุบัน',
    cancelBonusConMsg: 'ยกเลิกเงื่อนไขโบนัส',
    confirmMsg: 'ต้องการ',
    cancelMsg: 'ไม่ต้องการ',
    cancelOneMsg:
      'กรุณาโยกเงินทั้งหมดไปที่กระเป๋าตังค์หลัก ก่อนการกดยกเลิกโบนัสทุกครั้ง',
    cancelTwoMsg: '***เงินในเกมจะถูกเคลียร์ทั้งหมด***',
    cancelConBonusMsg: 'ยกเลิกเงื่อนไขโบนัส',
    closeMsg: 'ปิด',
    bonusType: 'คุณติดโบนัสประเภท'
  },
  profile: {
    id: 'หมายเลขสมาชิก',
    createdAt: 'เป็นสมาชิกตั้งแต่',
    contact: 'ข้อมูลการติดต่อ',
    bankDataTitle: 'ข้อมูลธนาคาร',
    bankAccLabel: 'ชื่อบัญชี',
    bankLabel: 'ธนาคาร',
    accNoLabel: 'เลขที่บัญชี'
  },
  statement: {
    statementTitle: 'ประวัติธุรกรรม',
    uploadStatusBtn: 'สถานะอัพโหลด',
    status: 'สถานะ',
    depositMsg: 'ฝากเงินเข้าบัญชี',
    bonusMsg: 'รับโบนัส',
    finishBonusMsg: 'สิ้นสุดโบนัส',
    withdrawMsg: 'ถอนเงินจาก',
    transferMsg: 'โอนเงิน',
    inProgressMsg: 'กำลังดำเนินการ',
    successMsg: 'สำเร็จ',
    failMsg: 'ไม่สำเร็จ'
  },
  spin: {
    confirm: 'ยืนยัน',
    cancel: 'ยกเลิก',
    claimPrize: 'รับรางวัล',
    claimPrizeSuccess: 'รับรางวัลสำเร็จ',
    receive: 'คุณได้รับ {label}',
    congratulation: 'ยินดีด้วย! คุณได้รับคูปอง',
    spinwheel: 'วงล้อ',
    spin: 'หมุน',
    index: 'ลำดับ',
    prize: 'รางวัล',
    amount: 'จำนวน',
    claim: 'รับ',
    error: {
      NO_CLAIMABLE_COUPON: 'ไม่สามารถรับคูปองได้',
      INVALID_PRIZE_CODE: 'ไม่พบคูปอง',
      INVALID_CODE: 'รหัสคูปองไม่ถูกต้อง',
      INVALID_COUPON_TYPE: 'ประเภทคูปองไม่ถูกต้อง',
      COUPON_EXPIRED: 'คูปองหมดอายุ',
      BONUS_REMAINING: 'มีโบนัสค้างอยู่'
    }
  },
  ranking: {
    pageTitle: 'อัพแรงค์',
    depositProgress: 'ยอดฝากสะสม ( รับโบนัสและไม่รับโบนัส )',
    claimBtn: 'ถอนโบนัสอัพแรงค์ {bonus} บาท',
    benefitsTitle: 'สิทธิประโยชน์',
    freeCreditLabel: '- ท่านจะได้รับเครดิตฟรี',
    maxWithdrawLabel: '- อั้นถอน',
    noWithdrawLimit: 'ไม่มีอั้นถอน',
    times: 'ครั้ง',
    successAmountLabel: '- ยอดสำเร็จ',
    baht: 'บาท',
    resetNote:
      '* สิทธิประโยชน์จะสิ้นสุดวันที่ {endDate}<br/>กรุณากดรับโบนัสตามวันและเวลาที่กำหนดไว้ด้วยนะคะ',
    modalTitle: 'รายละเอียดแรงค์',
    alreadyClaimedMsg: 'รับโบนัสแล้ว',
    goalReachedMsg: 'ยอดฝากถึงเงื่อนไขแล้ว กดรับโบนัสได้เลย',
    goalNotReachedMsg: 'ยอดฝากเดือนนี้ยังไม่ถึงเงื่อนไขของแรงค์นี้',
    claimSuccessMsg: 'รับโบนัสอัพแรงค์ {bonus} บาท สำเร็จ',
    noCampaignMsg: 'ไม่มีแคมเปญในขณะนี้',
    rewardClaimedLabel: 'รับรางวัลแล้ว',
    error: {
      BONUS_REMAINING: 'มีโบนัสค้างอยู่'
    }
  },
  modals: {
    confirmBtn: 'ตกลง',
    cancelBtn: 'ยกเลิก',
    saveBtn: 'บันทึก',
    successMsg: 'สำเร็จ',
    savedMsg: 'บันทึกข้อมูลสำเร็จ',
    errorMsg: 'เกิดข้อผิดพลาด',
    amountLabel: 'จำนวนเงิน (บาท)',
    receiveAtLabel: 'วันที่ได้รับ',
    transferMsg: 'โอนย้ายเงินสำเร็จ',
    agreement: {
      title: 'ข้อตกลงของการใช้งาน'
    },
    bonus: {
      title: 'โบนัส',
      receiveBtn: 'รับโบนัส'
    },
    changePassword: {
      title: 'เปลี่ยนรหัสผ่าน',
      oldPasswordLabel: 'รหัสผ่านเก่า',
      newPasswordLabel: 'รหัสผ่านใหม่',
      newConfirmPasswordLabel: 'ยืนยันรหัสผ่านใหม่',
      passwordNotEqualMsg: 'รหัสผ่านใหม่ไม่ตรงกัน'
    },
    condition: {
      title: 'เงื่อนไข'
    },
    deposit: {
      title: 'บัญชีสำหรับโอนเข้าเติมเงิน',
      noteOneTxt: 'บัญชีที่ใช้เติมเงิน จะต้องเป็นบัญชีด้านล่างนี้เท่านั้น',
      noteTwoTxt: '(โดยเงินจะถูกโอนเข้า Wallet ภายใน 1 นาที)',
      bank: 'ธนาคาร โอนแบบเลขบัญชี',
      qrcode: 'ธนาคาร โอนแบบสแกนคิวอาร์โค้ด',
      wallet: 'ฝากด้วย True Wallet',
      uploadSlipOneTxt: 'ระบบจะปิดการอัพโหลดเวลา',
      uploadSlipTwoTxt: 'น. ของทุกวัน',
      selectImageTxt: 'กรุณาเลือกไฟล์รูป',
      selectImageBtn: 'เลือกรูป',
      uploadBtn: 'อัพโหลด',
      conditionSlip1Txt:
        '** ต้องเป็นสลิปจริงเท่านั้น ห้ามใช้สลิปที่ capture เอง',
      conditionSlip2Txt:
        '** หลังจากโอนเงินต้องอัพโหลดสลิปภายใน 1 ชั่วโมงเท่านั้น',
      qr1Txt: 'สแกน QR code นี้เพื่อทำการโอนเงิน',
      qr2Txt: 'โปรดโอนภายในเวลา',
      qr3Txt: 'นาที',
      qr4Txt: '** หากโอนหลังเวลาดังกล่าว บริษัทขอสงวนสิทธิ์ไม่รับผิดชอบทุกกรณี',
      cancelBtn: 'ยกเลิก',
      transferBtn: 'โอนเงินเรียบร้อย',
      qrAmountTxt: 'กรอกจำนวนเงิน แล้วกดสร้าง QR code',
      qrCondition1Txt:
        '1. การฝากเข้าบัญชีลูกค้าต้องสร้างคิวอาร์โค้ดใหม่ทุกยอดโอน',
      qrCondition2Txt:
        '2. ชื่อบัญชีและเลขที่บัญชีที่ฝากต้องตรงกับที่สมัครเท่านั้น',
      qrCondition3Txt: '3. ยังไม่รองรับการโอนจาก ทรูวอลเลต',
      qrConditionWw1Txt:
        'QR Code ฝากได้เพียง 1 ครั้งเท่านั้น และโอนภายในเวลาที่กำหนดเท่านั้น',
      qrConditionWw2Txt:
        'ห้ามโอนซ้ำ ห้ามแก้ไขยอด ห้ามปัดเศษทศนิยม (หากไม่ปฏิบัติตามเงินจะไม่เข้าบัญชี ระบบจะไม่เติมเงิน/คืนเงินให้ลูกค้าทุกกรณี)',
      qrConditionWw3Txt: 'ฝากขั้นต่ำ {minDeposit} บาท',
      amountPla: 'จำนวนเงิน',
      qrCreateBtn: 'สร้าง QR code',
      linkTruePla: 'วางลิ้งค์ที่คัดลอก',
      linkSendBtn: 'ส่งลิ้งค์',
      refreshAmountMsg: 'กรุณากดรีเฟรชยอดเงินปัจจุบัน',
      uploadSuccessMsg: 'อัพโหลดสลิปสำเร็จ',
      linkSendMsg: 'ส่ง Link สำเร็จ',
      conditionTrueWalletAuto:
        '***ต้องใช้เบอร์โทรที่สมัคร (เบอร์ {username}) โอนมาเท่านั้น<br/><br/>***หากเบอร์วอลเลทไม่ตรงกับที่สมัคร แจ้งแอดมินเปลี่ยนเบอร์ก่อนทำรายการฝากเท่านั้น หากไม่ทำตามเงื่อนไขจะไม่รับผิดชอบใดๆ ทั้งสิ้น<br/><br/>***ยอดขั้นต่ำ 2 บาทขึ้นไป'
    },
    editProfile: {
      title: 'แก้ไขข้อมูลส่วนตัว',
      bankAccName: 'ชื่อบัญชี',
      bankLabel: 'ธนาคาร',
      bankAccNoLabel: 'เลขที่บัญชี'
    },
    invite: {
      title: 'แนะนำเพื่อน',
      linkSendTxt: 'ส่งลิ้งค์นี้ให้เพื่อน',
      copyTxt: 'คัดลอก',
      inviteTurnoverBtn: 'สะสมค่าแนะนำเพื่อน',
      fromLabel: 'ได้รับจาก',
      amountLabel: 'จำนวนเงิน (บาท)',
      createdAtLabel: 'วันที่ได้รับ'
    },
    promotion: {
      title: 'โปรโมชั่น',
      promo1Txt: '*** การยกเลิกโบนัส หากยอดเงินฝากรวมโบนัสต่ำกว่า',
      promo2Txt: 'สมาชิกต้องกดยกเลิกโบนัสก่อนทำรายการฝากครั้งต่อไป',
      promo3Txt: 'ไม่กดเงินฝากจะติดเทิร์น',
      receivePromoBtn: 'กดรับโปรโมชั่น',
      searchingMsg: 'กำลังค้นหา',
      promoNotFoundMsg: 'ไม่พบโปรโมชั่นนี้'
    },
    refund: {
      title: 'คืนยอดเสีย',
      refundAmountLabel: 'ยอดสะสมคืนยอดเสีย',
      receiveBtn: 'รับ',
      receiveRefundBtn: 'รับเงินคืนยอดเสีย',
      refundCon1Txt: 'ไม่สามารถรับเงินคืนยอดเสียได้',
      refundCon2Txt: 'เนื่องจากคุณติดโบนัสอยู่',
      refundNotFondTxt: 'ไม่พบข้อมูลการขอคืนยอดเสีย',
      refundToWallet1Msg: 'ต้องการรับยอดคืนยอดเสีย',
      refundToWallet2Msg:
        'หากท่านกดรับ จะทำให้เงินใน wallet และ เกมทั้งหมด ติดเงื่อนไขด้วย',
      refundToWallet3Msg: 'เงื่อนไข ต้องทำให้ได้เงิน',
      refundToWallet4Msg: 'ของยอดคืนยอดเสีย',
      refundToWallet5Msg: 'การยกเลิกโบนัส หากยอดเงินฝากรวมโบนัสต่ำกว่า',
      refundToWallet6Msg: 'สมาชิกต้องกดยกเลิกโบนัสก่อนทำรายการฝากครั้งต่อไป',
      refundToWallet7Msg: 'ไม่กดเงินฝากจะติดเทิร์น'
    },
    slip: {
      title: 'รายการอัพโหลด',
      currentStatusTxt: 'เช็คสถานะปัจจุบัน',
      statusLabel: 'สถานะ',
      imgLabel: 'รูป',
      selectView: 'เรียกดู',
      inProgressMsg: 'กำลังดำเนินการ',
      successMsg: 'สำเร็จ',
      failMsg: 'ไม่สำเร็จ',
      incorrectSlipMsg: 'สลิปไม่ถูกต้อง',
      destAccInvalidMsg: 'เลขบัญชีปลายทางไม่ถูกต้อง',
      duplicateSlipMsg: 'สลิปซ้ำ',
      unstableRefNoMsg: 'ไม่สามารถอ่าน Ref ได้',
      wrongCaptchaMsg: 'captcha ผิดสามครั้งติดกัน',
      invalidSlipMsg: 'ไม่สามารถอ่านสลิปได้',
      notMatchMsg: 'เลขบัญชีผู้เล่นไม่ตรงกับที่สมัคร',
      expiredSlipMsg: 'สลิปหมดอายุแล้ว',
      unknownErrorMsg: 'พบข้อผิดพลาด กรุณาติดต่อแอดมิน'
    },
    slotAccount: {
      resetPasswordTxt: 'รีเซ็ตรหัสผ่าน',
      canNotPlayTxt: 'เมื่อเข้าเล่นเกมส์ไม่ได้',
      transferToGameLabel: 'โยกเงินเข้าเกมส์ (บาท)',
      haveAmountTxt: 'มีเงินอยู่ในเกมส์',
      playGameBtn: 'เล่นเกมส์',
      androidAppBtn: 'แอพบน Android',
      iosAppBtn: 'แอพบน iOS',
      activeBtn: 'เปิดการใช้งาน'
    },
    transfer: {
      title: 'โอนเงิน',
      selectAccTxt: 'เลือกบัญชี',
      transferFromTxt: 'โอนจาก',
      walletTxt: 'Wallet (บาท)',
      transferToTxt: 'ไปยัง',
      bahtTxt: 'บาท',
      minAmountLabel: 'ขั้นต่ำ',
      amountPla: 'จำนวนเงิน',
      transferBtn: 'โอนเงิน',
      selectAccMsg: 'กรุณาเลือกบัญชีให้ถูกต้อง',
      canNotTransferMsg: 'ไม่สามารถเลือกโอน/รับบัญชีเดียวกัน',
      minAmountMsg: 'จำนวนเงินขั้นต่ำคือ'
    },
    withdraw: {
      title: 'ถอนเงิน',
      amountWithdrawTxt: 'จำนวนเงินที่ถอนได้ (บาท)',
      maxTxt: 'สูงสุด',
      bonusConTxt:
        'กรุณาแจ้งถอนยอดเงินทั้งหมดเท่านั้น หากรับโปรแล้วแจ้งถอนไม่หมด เครดิตที่เหลือไว้จะโดนตัดออกทั้งหมด',
      confBrn: 'ยืนยัน',
      maxAmountMsg: 'จำนวนเงินสูงสุดคือ',
      waiteTransfer: 'กรุณารอรับเงินเข้าบัญชี'
    },
    editBankAccName: {
      title: 'ชื่อ-สกุลบัญชีธนาคาร',
      warningTxt: 'กรุณาแก้ไข ชื่อ-สกุลบัญชีธนาคาร ให้เป็น ภาษาอังกฤษ เท่านั้น',
      accNamePla: 'ชื่อ-นามสกุลบัญชี (ภาษาอังกฤษ)',
      editBtn: 'แก้ไข',
      requiredEngLangMsg: 'ชื่อบัญชีต้องเป็นภาษาอังกฤษเท่านั้น'
    }
  },
  bottomMenu: {
    home: 'หน้าหลัก',
    register: 'สมัครสมาชิก',
    howTo: 'วิธีการใช้งาน',
    contact: 'ติดต่อเรา'
  },
  bottomMenuAuth: {
    home: 'หน้าหลัก',
    profile: 'ข้อมูลส่วนตัว',
    condition: 'เงื่อนไข',
    statement: 'ประวัติธุรกรรม',
    contact: 'ติดต่อเรา'
  },
  errorMsg: {
    UNAUTHORIZED: 'ปฏิเสธการเข้าใช้งาน เนื่องจากไม่ได้ login',
    EXPIRED_AUTH_TOKEN: 'ปฏิเสธการเข้าใช้งาน เนื่องจาก token หมดอายุ',
    INVALID_USER_1: 'ไม่สามารถยืนยันตัวตนได้',
    INVALID_USER_2: 'ไม่สามารถยืนยันตัวตนได้',
    INVALID_USER_3: 'ไม่สามารถยืนยันตัวตนได้',
    INVALID_USER_4: 'ไม่สามารถยืนยันตัวตนได้',
    INVALID_IP: 'ไม่สามารถเข้าใช้งานได้เนื่องจาก IP address',
    NOT_AREASLOT: 'ไม่พบผู้ใช้นี้ใน AREASLOT',
    NOT_UFABET: 'ไม่พบผู้ใช้นี้ใน UFABET',
    OTP_BLOCK: 'ท่านทำรายการติดกันเกินไป กรุณารอสักครู่',
    OTP_TOKEN_INVALID: 'ไม่สามารถยืนยัน OTP ดังกล่าว',
    OTP_NOT_EXIST: 'ไม่สามารถยืนยัน OTP ดังกล่าว',
    OTP_VERIFIED: 'รหัส OTP ถูกยืนยันไปแล้ว',
    OTP_EXPIRED: 'รหัส OTP หมดอายุ',
    OTP_CODE_INVALID: 'รหัส OTP ไม่ถูกต้อง',
    OTP_CODE_VALID: 'ตรวจสอบ OTP ถูกต้อง',
    EXISTING_USER: 'เบอร์โทรนี้ได้ลงทะเบียนไปแล้ว',
    EXISTING_BANK: 'บัญชีธนาคารนี้ได้ถูกใช้งานแล้ว',
    INVALID_USER_INFO: 'ข้อมูลผู้ใช้ไม่ถูกต้อง',
    UNVERIFIED_OTP: 'กรุณายืนยันเบอร์โทร',
    GAME_ACTIVATION_FAIL: 'ไม่สามารถเปิดการใช้งานได้',
    INVALID_BANK: 'ข้อมูลธนาคารไม่ถูกต้อง',
    BANK_ACCOUNT_NAME_ENG: 'ชื่อบัญชีต้องเป็นภาษาอังกฤษเท่านั้น',
    REGISTER_FAIL: 'สมัครสมาชิกไม่สำเร็จ',
    NO_USER: 'ไม่พบข้อมูลผู้ใช้งานนี้',
    WRONG_PASSWORD: 'รหัสผ่านไม่ถูกต้อง',
    REQUEST_LIMIT: 'ท่านทำรายการติดกันเกินไป กรุณารอสักครู่',
    WRONG_CREDENTIAL: 'เบอร์โทร/รหัสผ่าน ไม่ถูกต้อง',
    INACTIVE_USER: 'ผู้ใช้งานนี้ถูกปิดการใช้งาน',
    LOGIN_FAIL: 'ไม่สามารถใช้งานได้ในขณะนี้',
    BONUS_REMAINING: 'มีโบนัสค้างอยู่',
    BONUS_ALREADY_ACTIVE: 'โบนัสนี้ถูกใช้งานอยู่แล้ว',
    BONUS_MAX_CLAIMED: 'ไม่สามารถรับโบนัสนี้ได้แล้ว',
    BONUS_CONDITION: 'คุณไม่สามารถยกเลิกโบนัสได้ เนื่องจากติดเงื่อนไขอยู่',
    BONUS_CLEAR: 'ยกเลิกโบนัสเรียบร้อยแล้ว',
    INVITE_COLLECT: 'ระบบจะสะสมให้อัตโนมัติ',
    INTERNAL_SERVER_ERROR: 'ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง',
    INVITE_INACTIVE: 'ปิดโบนัสแนะนำเพื่อน',
    NO_INVITE_BONUS: 'ไม่พบโบนัสแนะนำเพื่อน',
    NO_INVITEE_PLAY_INFO: 'ไม่พบข้อมูลการเล่นของเพื่อนที่คุณแนะนำ',
    INVITE_BONUS_SUCCESS: 'คุณได้รับโบนัสเรียบร้อยแล้ว',
    INVITE_BONUS_FAIL: 'คุณไม่ได้รับโบนัส',
    OK: 'ok',
    KEY_MISSING: 'ไม่พบคีย์',
    KEY_INVALID: 'คีย์ไม่ถูกต้อง',
    SUCCESS: 'สำเร็จ',
    OTP_SEND_FAIL: 'ไม่สามารถส่ง OTP ได้',
    OTP_VERIFY_FAIL: 'ไม่สามารถยืนยัน OTP ได้',
    NO_DATA: 'ไม่พบข้อมูล',
    NO_PROMOTION: 'ไม่พบโปรโมชั่นนี้',
    PROMOTION_RECEIVED: 'ท่านได้รับโปรโมชั่นนี้ไปแล้ว',
    BONUS_FULL: 'โปรโมชั่นเต็มแล้ว',
    QR_FAIL: 'ไม่สามารถสร้าง QR Code ได้ กรุณาลองใหม่อีกครั้ง',
    NO_REFUND: 'ไม่พบการคืนยอดเสีย',
    REFUND_CONDITION: 'ท่านไม่อยู่ในเงื่อนไขการรับเงินคืนยอดเสีย',
    REFUND_SUCCESS: 'ท่านได้รับเงินคืนยอดเสียเรียบร้อย',
    REFUND_INACTIVE: 'ระบบคืนยอดเสียถูกปิดไว้',
    REFUND_MINIMUM: 'ยอดสะสมต้องมากกว่า 0 บาท',
    NO_BANK: 'ไม่พบข้อมูลบัญชีธนาคารของผู้ใช้งานนี้',
    NO_WALLET: 'ไม่พบข้อมูล wallet ของผู้ใช้งานนี้',
    SLOT_ALREADY_ACTIVE: 'เกมส์นี้ได้เปิดใช้งานแล้ว',
    SLOT_ACTIVATE_FAIL: 'ไม่สามารถเปิดการใช้งานได้',
    SLOT_NO_ACCOUNT: 'ไม่พบบัญชีผู้ใช้งานของเกมส์นี้',
    SLOT_RESET_PASSWORD_FAIL: 'ไม่สามารถเปลี่ยนรหัสผ่านได้',
    TRANSFER_MINIMUM: 'จำนวนเงินต้องมากกว่า 0',
    NO_GAME: 'ไม่พบข้อมูลของเกมส์',
    MONEY_NOT_ENOUGH: 'จำนวนเงินไม่เพียงพอ',
    TRANSFER_FAIL:
      'โอนเงินไม่สำเร็จ โดยเงินได้ถูกโอนกลับเข้า Wallet เรียบร้อยแล้ว',
    SLIP_UPLOAD_FAIL: 'ไม่สามารถทำรายการได้',
    REQUEST_LIMIT_1MIN: 'ท่านทำรายการติดกันเกินไป กรุณารอประมาณ 1 นาที',
    SLIP_NO_FILE: 'ไม่ได้อัพโหลดไฟล์',
    SLIP_INVALID_FILE: 'ไฟล์ภาพไม่ถูกต้อง',
    TRUELINK_DUPLICATE: 'Link ซ้ำ',
    TRUELINK_INVALID: 'Link ไม่ถูกต้องหรือถูกใช้ไปแล้ว',
    PHONE_NUMBER_REQUIRE_10_DIGIT: 'เบอร์โทรศัพท์ต้องมีความยาว 10 หลัก'
  }
}
